<form #createConsultaForm="ngForm">
  <div class="custom-header">
    <div class="row align-items-center">
      <div class="col d-flex justify-content-center">
        <h4 class="modal-title" id="modal-title">Anexar Exame</h4>
      </div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="btn-close" (click)="cancel()">
          <img src="../../../../assets/img/icons/close.svg" alt="Fechar">
        </button>
      </div>
    </div>

  </div>

  <div class="modal-body">
    <div class="modal-body-container">

      <div class="container">
        <div class="mb-4">
          <label for="" class="form-label required">Arquivo</label>
          <div class="custom-file file-upload-custom">
            <input type="file" class="custom-file-input" id="file" (change)="handleUpload($event)"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf,application/vnd.ms-powerpoint,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,image/*,audio/*,video/*">
            <label class="custom-file-label" for="file" data-browse="Buscar">
              Clique para selecionar o arquivo...</label>
            <small *ngIf="exame" class="form-text text-muted">
              {{ exame?.fileNameWithOutExtension }}</small>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="custom-footer">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-6 d-flex align-items-center justify-content-center">
        <button type="button" class="btn w-50 btn-cancelar" (click)="cancel()">
          Cancelar
        </button>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-center">
        <button type="submit" class="btn primary-white-button w-100" (click)="save()"
          [disabled]="!exame || saving">
          Anexar
          <i class="ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</form>
